import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, catchError, from, of, shareReplay, switchMap, takeUntil, tap } from 'rxjs';
import { UserData } from '@app/shared/models/user-data.model';
import { ChatAuthor, ChatMessage, SamplePrompt } from '@shared/models/ask-our-data.model';
import { PromptSettings } from '@shared/models/prompt-settings.model';
import { PromptInputComponent } from '@app/shared/components/prompt-input/prompt-input.component';
import { AskOurDataService } from '@app/core/services/ask-our-data/ask-our-data.service';
import { ClipboardService } from "ngx-clipboard";
import { Messages } from '@app/shared/constants/ask-our-data-constants';
import { PlotlyService }  from 'src/app/core/services/ask-our-data/plotly.service';
import { featureFlags } from '@app/environments/environment';
import { AlertService } from '@app/core/services/alert/alert.service';
import { LZStringService } from '@app/core/services/ask-our-data/lz-string.service';
import { KmdModalService } from 'gds-atom-components';
import { ContextMenuComponent } from '@app/shared/components/context-menu/context-menu.component';
import { ContextMenuItem } from '@app/shared/components/context-menu/context-menu';
import { AodChatHistoryComponent } from '@app/ask-our-data/chat-with-db/chat-history/aod-chat-history.component';
import { isObject, omit } from 'lodash';
import { AskOurDataUtils } from '@app/core/utils/ask-our-data-utils';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { AuthService } from "@services/auth/auth.service";

@Component({
  selector: 'app-chat-with-db-new',
  templateUrl: './chat-with-db-new.component.html',
  styleUrls: ['./chat-with-db-new.component.css']
})
export class ChatWithDbNewComponent implements OnInit, OnDestroy, AfterViewInit{
  @ViewChild('promptInputComponent') promptInputComponent!: PromptInputComponent;
  @ViewChild('ContextMenuComponent') modelDropdown!: ContextMenuComponent;
  @ViewChild('chatHistory') chatHistoryComponent!: AodChatHistoryComponent;
  userData$: Observable<UserData>;
  selectedChatId: string = '';
  promptSettings: PromptSettings;
  isLoading: boolean = false;
  generatingResponse: boolean = false;
  receivedResponse: boolean[] = [];
  lastSystemMessage?: ChatMessage;
  dbname = '';
  dbId = '';
  ischatEmpty = true;
  isDbConnectErr = false;
  private subscriptions = new Subscription();
  generateSqlFailed = false;
  generatingChart: boolean[] = [];
  showLoader = false;

  messages: ChatMessage[] = [];
  visibleMessages: ChatMessage[] = [];
  showSavePrompt: boolean = false;
  showCopyPrompt: boolean = true;
  inputPrompt: string = '';
  generateSubscription: Subscription | undefined;
  runSqlSubscription: Subscription | undefined;
  sqlResponse = '';
  showErrorIcon: boolean[] = [];
  jsonResponse: any;
  resultObtained: boolean[] = [];
  protected readonly featureFlags = featureFlags;
  graphData: any[] = [];
  graphCIData: any[] = [];
  graphLayout: any = {};
  graphCILayout: any = {};
  openGraph: boolean[] = [];
  chartGenerated: boolean[] = [];
  chartAPICalled: boolean[] = [];
  sessionId = AskOurDataUtils.generateSessionId();
  groupId = 1;
  chat_id: string | null = null;
  userScrolling = false;
  isConversationResponse: any = [];
  chatInteractions: any[] = [];
  oid = '';
  consent = false;
  consentAPIFailed = false;
  samplePrompts: SamplePrompt[] = [];
  chartType: any;
  chartTypes = [];
  xaxis: string = '';
  yaxis: string = '';
  headers: any[] = [];
  jsonResponses: any[] = [];
  selectedPromptValue = '';
  selectedSql = '';
  predictiveText: any[] = [];
  itemsList: ContextMenuItem[] = [];
  showModelDropdown: boolean = false;
  chatHistoryDataLimit = 20;
  userAuthor: ChatAuthor = new ChatAuthor("USER");
  systemAuthor: ChatAuthor = new ChatAuthor("SYSTEM");
  copyInterval: any[] = [];
  copyCount: any[] = [];
  chartSubscription: Subscription | undefined;
  sqlResultObtained: boolean[] = [];
  @HostListener('window:unload', [ '$event' ])
  unloadHandler() {
    AskOurDataUtils.removeLocalStorage();
  }
  destroy$: Subject<boolean> = new Subject<boolean>();
  oldChatInteractions: any[] = [];
  isExpanded = false;
  graphErrorMessage: any[] = [];
  generatingData: boolean[] = [];

  feedbackType: {[key: number]: string} = {};
  feedbackFormOpened: {[key: number]: string} = {};
  toolUsed: {[key: number]: string} = {};
  chatIdMap: {[key: number]: string} = {};
  userInputPrompt: {[key: number]: string} = {};
  responseDataForFeedback: {[key: number]: any} = {};


  constructor(private router: Router,
    @Inject('AOD_FEEDBACK_TIMESTAMP_LIMIT') private feedbackTimeStampLimit: number,
    private askOurDataService: AskOurDataService,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private clipboard: ClipboardService,
    private alertService: AlertService,
    private plotly: PlotlyService,
    private lZStringService: LZStringService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private kmdModalService: KmdModalService) {
    this.userData$ = authService.userData$.pipe(
      tap(result => {
        this.oid = result.oid;
      })
    );
    this.promptSettings = new PromptSettings(0, 'PROFESSIONAL', false, 'gpt-4-o');
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.dbId = params['id'];
      this.dbname = params['name'];
    });
    this.itemsList = [
      {
        id: "0",
        label: "History",
        description: "See all chat history with the database",
        imageUrl: "../../../../assets/icons/clock/clock-24px-mono-new.svg"
      }
    ]
  }

  ngAfterViewInit(): void {
    this.showLoader = true;
    this.askOurDataService.getNavigationStatus(this.oid, parseInt(this.dbId, 10)).subscribe({
      next: (response) => {
        this.showLoader = false;
        if(!response || !response.is_acknowledged) {
          this.kmdModalService.open('consentModal');
        }
      },
      error : (error) => {
        /* istanbul ignore else */
        if (error?.error?.error_message !== 'User navigation status not found') {
          this.consentAPIFailed = true;
        }
        this.showLoader = false;
        this.kmdModalService.open('consentModal');
      }
    });
  }

  async onSubmit(inputPrompt: string, regenerate: boolean = false) {
    this.chat_id = regenerate ? this.chat_id : null;
    if (this.isLoading || inputPrompt.trim() === "") return;

    this.groupId++;
    this.resultObtained[this.groupId] = false;
    this.isConversationResponse[this.groupId] = false;
    this.showErrorIcon[this.groupId] = false;
    this.isDbConnectErr = false;
    this.inputPrompt = inputPrompt;
    this.userInputPrompt[this.groupId] = inputPrompt;
    this.receivedResponse[this.groupId] = false;
    this.ischatEmpty = false;
    this.generatingResponse = true;
    this.generateSqlFailed = false;

    const promptValue = inputPrompt.trim();
    this.promptInputComponent.setPrompt('');
    const author = this.userAuthor;
    const message = new ChatMessage('', promptValue, '', author, new Date().toISOString(), promptValue, this.lastSystemMessage?.id, this.groupId);
    message.id = 'chat_' + this.groupId;
    this.addMessage(message);
    this.isLoading = true;
    this.cdRef.detectChanges();
    this.scrollToChat('USER');
    let requestData = {
        "database_id": this.dbId,
        "question": promptValue,
        "session_id": this.sessionId,
        chat_history: this.chatInteractions.length > 0
          ? this.chatInteractions.map(interaction => omit(interaction, 'groupId'))
          : null,
        "is_summary": true,
        "is_plot": true,
        "is_regenerate": regenerate,
    };

    let chatMessages: any[] = [];

    this.askOurDataService.fetchResponse(requestData)
    .pipe(takeUntil(this.destroy$)).subscribe({
      next: (event: HttpEvent<string>) => this.handleStreamData(event, promptValue, chatMessages),
      error: (error) => this.handleChatError(error),
      complete: () => {
          this.isLoading = false;
          this.generatingData[this.groupId] = false;
          this.generatingResponse = false;
          this.receivedResponse[this.groupId] = true;
          this.destroy$.next(true);
          this.cdRef.detectChanges();
        }
    });

    this.subscriptions.add(this.generateSubscription);
  }

  handleStreamData(event: any, promptValue: string, chatMessages: any[] = []) {
        switch(event.type) {
          case "reframed_question":
            if(event.status === 'success' && event.value) {
            // handle the reframed question
              let chatInteraction = this.chatInteractions.find(interaction => interaction.groupId === this.groupId && interaction.role === 'user')
              if(chatInteraction) {
                chatInteraction.content = event.value;
              } else {
                this.chatInteractions.push({
                  groupId: this.groupId,
                  "role": "user",
                  "content": event.value,
                  "content_type": "Question"
                });
              }
            }
            break;
          case "chat_id":
            if(event.status === 'success' ) {
              this.chatIdMap[this.groupId] = event.value;
              this.chat_id = event.value;
            }
            break;
          case "chat_history_summary":
            if(event.status === 'success' && event.value) {
              this.chatInteractions = [];
              chatMessages.push({
                groupId: this.groupId,
                "role": "assistant",
                "content": event.value,
                "content_type": "chat_history_summary"
              });
            }
            break;
          case "analytics":
            if(event.status === 'success') {
              this.handleStreamingPrediction(event, promptValue);
              this.generatingResponse = false;
              this.generatingData[this.groupId] = true;
            } else if(event.status === 'error') {
              if (event.status_code === 204) {
                this.handleEmptyResponse();
                this.scrollToChat('SYSTEM');
              } else {
                this.handleErrorStatus({status: event.status_code, error_message: event.value}, promptValue);
              }
            }
          break;
          case "sql":
            if(event.status === 'success') {
              if(!event.value) {
                this.handleEmptyResponse();
                this.scrollToChat('SYSTEM');
              } else {
                this.sqlResultObtained[this.groupId] = true;
                this.chatInteractions.push({
                  groupId: this.groupId,
                  "role": "user",
                  "content": promptValue,
                  "content_type": "Question"
                });
                this.chatInteractions.push({
                  groupId: this.groupId,
                  "role": "assistant",
                  "content": event.value,
                  "content_type": "sql"
                });
                const systemResponse = new ChatMessage('', event.value, '', this.systemAuthor, new Date().toISOString(), event.value, '1', this.groupId);
                systemResponse.id = 'child_chat_' + this.groupId;
                systemResponse.parentId = 'chat_' + this.groupId;
                chatMessages.push(systemResponse);
                this.addMessage(systemResponse);
                this.generatingResponse = false;
                this.generatingData[this.groupId] = true;
                this.scrollToChat('SYSTEM');
                this.cdRef.detectChanges();
              }
            } else {

              if (event.status_code === 204) {
                this.handleEmptyResponse();
              } else {
                this.handleErrorStatus({status: event.status_code, error_message: event.value}, promptValue);
              }

              this.scrollToChat('SYSTEM');
              this.generatingResponse = false;
              this.receivedResponse[this.groupId] = true;
              this.isLoading = false;
              this.showErrorIcon[this.groupId] = true;
              this.generateSqlFailed = true;
            }
          break;
          case "chat":
            if(event.status === 'success') {

              this.chatInteractions.push({
                groupId: this.groupId,
                "role": "user",
                "content": promptValue,
                "content_type": "Question"
              });
              this.chatInteractions.push({
                groupId: this.groupId,
                "role": "assistant",
                "content": event.value,
                "content_type": "chat_response"
              });

              this.isConversationResponse[this.groupId] = true;

              this.responseDataForFeedback[this.groupId] = event.chat || null;
              const formattedResponse = `<div class="copyable-${this.groupId}">${event.chat}</div>`;
              const finalSystemResponse = new ChatMessage('', formattedResponse, '', this.systemAuthor, new Date().toISOString(), event.chat, '1', this.groupId);
              finalSystemResponse.id = 'child_chat_' + this.groupId;
              finalSystemResponse.parentId = 'chat_' + this.groupId;
              this.addMessage(finalSystemResponse);
              this.cdRef.detectChanges();
              this.scrollToChat('SYSTEM');
            } else {

              if (event.status_code === 204) {
                this.handleEmptyResponse();
              } else {
                this.handleErrorStatus({status: event.status_code, error_message: event.value}, promptValue);
              }
              this.generatingResponse = false;
              this.receivedResponse[this.groupId] = true;
              this.isLoading = false;
              this.showErrorIcon[this.groupId] = true;
              this.generateSqlFailed = true;
              this.scrollToChat('SYSTEM');
            }
          break;
          case "run":
            if(event.status === 'success') {
              if(event.df_json) {
                if(chatMessages.length > 0) {
                  let jsonResponse = JSON.parse(event?.df_json || "[]");
                  this.sqlResponse = event.df_markdown;
                  let responseMessage = this.createJsonTableData(jsonResponse, chatMessages[0], promptValue, chatMessages[0].text);


                  this.chatInteractions.push({
                    groupId: this.groupId,
                    "role": "assistant",
                    "content": JSON.stringify(jsonResponse.slice(0, this.chatHistoryDataLimit)),
                    "content_type": "sql_result"
                  });

                  let systemRunSqlResponse = new ChatMessage(chatMessages[0].text, responseMessage, '', this.systemAuthor, new Date().toISOString(), promptValue, '1', this.groupId, '', chatMessages[0].text);
                  systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                  systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                  chatMessages.push(systemRunSqlResponse);
                  this.addMessage(chatMessages[0]);
                  this.addMessage(systemRunSqlResponse);
                  this.scrollToChat('SYSTEM');
                  this.cdRef.detectChanges();

                } else {

                  const systemResponse = new ChatMessage(chatMessages[0]?.text, event.value, '', this.systemAuthor, new Date().toISOString(), event.value, '1', this.groupId);
                  systemResponse.id = 'child_chat_' + this.groupId;
                  systemResponse.parentId = 'chat_' + this.groupId;
                  chatMessages.push(systemResponse);
                  this.addMessage(systemResponse);
                  this.scrollToChat('SYSTEM');
                  this.cdRef.detectChanges();
                }
              } else {
                this.generateSqlFailed = true;
                this.showErrorIcon[this.groupId] = true;
                // let sqlErr =  `<p>` + sql + `</p><p>` + Messages.NO_RESPONSE + `</p>`;
                let sqlErr =  `<p>` + Messages.NO_RESPONSE + `</p>`;
                let systemRunSqlResponse = new ChatMessage('', sqlErr, '', this.systemAuthor, new Date().toISOString(), promptValue, 'childId_'+this.groupId, this.groupId);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                this.addMessage(systemRunSqlResponse);
                this.scrollToChat('SYSTEM');
              }


            } else {

              let error = {
                status: event.status_code,
                error_message: event.value
              };


              if (error.status === 503) {
                this.isDbConnectErr = true;
              } else if (error.status === 400) {
                this.generateSqlFailed = true;
                this.showErrorIcon[this.groupId] = true;
                let injectionErr = (error.error_message.match(/^SQL injection\.*/g) ? Messages.NO_ACTION_ALLOWED :  Messages.INTERNAL_SERVER_ERROR);
                let sqlErr =  (error.error_message.match(/^Syntax error\.*/g)) ? Messages.GENERATE_SQL_ERROR : injectionErr;
                let sqlErrMsg = `<p>` + sqlErr + `</p>`;
                let systemRunSqlResponse = new ChatMessage('', sqlErrMsg, '', this.systemAuthor, new Date().toISOString(), promptValue, 'childId_'+this.groupId, this.groupId);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                this.addMessage(systemRunSqlResponse);
              } else if (error.status === 204) {
                this.receivedResponse[this.groupId] = true;
                this.generateSqlFailed = true;
                this.showErrorIcon[this.groupId] = true;
                // let sqlErr =  `<p>` + sql + `</p><p>` + Messages.NO_RESPONSE + `</p>`;
                let sqlErr =  `<p>` + Messages.NO_RESPONSE + `</p>`;
                let systemRunSqlResponse = new ChatMessage('', sqlErr, '', this.systemAuthor, new Date().toISOString(), promptValue, 'childId_'+this.groupId, this.groupId);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                this.addMessage(systemRunSqlResponse);
              } else if (error.status === 504) {
                this.generateSqlFailed = true;
                this.showErrorIcon[this.groupId] = true;
                let sqlErr =  `<p>` + Messages.GATEWAY_TIMEOUT_ERROR + `</p>`;
                let systemRunSqlResponse = new ChatMessage('', sqlErr, '', this.systemAuthor, new Date().toISOString(), promptValue, 'childId_'+this.groupId, this.groupId);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                this.addMessage(systemRunSqlResponse);
              } else {
                let sqlErr =  `<p>` + Messages.INTERNAL_SERVER_ERROR + `</p>`;
                this.generateSqlFailed = true;
                this.showErrorIcon[this.groupId] = true;
                let systemRunSqlResponse = new ChatMessage('', sqlErr, '', this.systemAuthor, new Date().toISOString(), promptValue, 'childId_'+this.groupId, this.groupId);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                this.addMessage(systemRunSqlResponse);
              }
              this.scrollToChat('SYSTEM');

            }
          break;
          case "plot":
            this.generatingData[this.groupId] = false;
            this.generatingResponse = false;
            if(event.status === 'success') {
              this.handlePlotData(event.value, promptValue);
              this.scrollToChat('SYSTEM');
            } else {
              this.handleChartError(event?.status_code);
              this.scrollToChat('SYSTEM');
            }
          break;
          case "summary":
            if(event.status === 'success') {
              if(chatMessages.length > 0) {

                this.chatInteractions.push({
                  groupId: this.groupId,
                  "role": "assistant",
                  "content": event.value || 'No results or match was found for the query',
                  "content_type": "sql_result_summary"
                });

                let systemRunSqlResponse = new ChatMessage(chatMessages[0]?.text, chatMessages[1]?.text, '', this.systemAuthor, new Date().toISOString(), promptValue, '1', this.groupId, event.value, chatMessages[0].text);
                systemRunSqlResponse.id = 'child_chat_' + this.groupId;
                systemRunSqlResponse.parentId = 'chat_' + this.groupId;
                chatMessages.push(systemRunSqlResponse);
                this.addMessage(systemRunSqlResponse);
                this.scrollToChat('SYSTEM');
                this.cdRef.detectChanges();


              } else {
                // no summary

              }

            } else {

              // no summary
            }
          break;
          case "tool_call":
            if(event.status === 'success') {
              this.toolUsed[this.groupId] = event.value;
            }

        }

  }

  handleStreamingPrediction(response: any, promptValue: any, msg = '') {
    let predictiveText = response;

    if (predictiveText) {
      let updatedPredictiveText = { ...predictiveText };
      delete updatedPredictiveText.original_dataframe;
      delete updatedPredictiveText.s3_link;
      delete updatedPredictiveText.base64_string;
      delete updatedPredictiveText.display_chart;
      delete updatedPredictiveText.sql_query;

      this.responseDataForFeedback[this.groupId] = JSON.stringify(updatedPredictiveText) || null;
    }

    let updateDF = predictiveText?.updated_dataframe;
    if(updateDF) {
      updateDF = updateDF.replaceAll('NaN,', '\" \",');
    }
    let updatedDataframe = JSON.parse(updateDF || "[]");

    this.chatInteractions.push(
      { groupId: this.groupId ,role: "user", content: promptValue, content_type: "Question" },
      { groupId: this.groupId ,role: "assistant", content: predictiveText?.analysis_output || '', content_type: "chat_response" }
    );

    this.generatingResponse = false;
    this.receivedResponse[this.groupId] = false;
    this.isLoading = false;
    this.resultObtained[this.groupId] = true;
    this.isConversationResponse[this.groupId] = true;

    let formattedResponse =  '';
    try {
      let predictData = JSON.parse(predictiveText?.analysis_output);
      predictiveText.key_takeaways = predictData.key_takeaways;
      predictiveText.recommendations = predictData.recommendations;
      let keys = Object.keys(predictData);
      keys.forEach((key) => {
        if (key !== 'key_takeaways' && key !== 'recommendations') {
          let newKeyValue = key;
          let newUpdateKey = capitalizeFirstLetter(newKeyValue);
          if (predictData[key] && Array.isArray(predictData[key]) && predictData[key].length > 0) {
            formattedResponse += '\n ## '+ newUpdateKey +': \n' + predictData[key].join(' \n');
          } else {
            formattedResponse += '\n ## '+ newUpdateKey +': \n' + predictData[key];
          }
        }
      });
    } catch (e) {
      formattedResponse = predictiveText?.analysis_output || '';
      console.log("Error parsing JSON:", e);
    }


    let predictiveContent = '';
    if(predictiveText.key_takeaways) {
      predictiveContent += '## Key Takeaways: \n' + predictiveText.key_takeaways.join(' \n');
    }
    if(predictiveText.recommendations) {
      predictiveContent += '\n ## Recommendations: \n' + predictiveText.recommendations.join(' \n');
    }
    const finalSystemResponse = new ChatMessage('', formattedResponse, predictiveContent, this.systemAuthor, new Date().toISOString(), msg, '1', this.groupId);
    finalSystemResponse.id = 'child_chat_' + this.groupId;
    finalSystemResponse.parentId = 'chat_' + this.groupId;
    this.addMessage(finalSystemResponse);

    if(updatedDataframe && updatedDataframe.length > 0) {
      setTimeout(() => {
        const tableResponse = this.createJsonTableData(updatedDataframe, finalSystemResponse, promptValue, predictiveText?.sql_query, true);
        const finalPredictiveSystemResponse = new ChatMessage(finalSystemResponse.text, tableResponse, predictiveContent, this.systemAuthor, new Date().toISOString(), msg, '1', this.groupId);
        finalPredictiveSystemResponse.id = 'child_chat_' + this.groupId;
        finalPredictiveSystemResponse.parentId = 'chat_' + this.groupId;
        this.addMessage(finalPredictiveSystemResponse);
      }, 200);
    }

    this.cdRef.detectChanges();
    this.scrollToChat('SYSTEM');
    this.handlePlotData(predictiveText.s3_link, promptValue, predictiveText.display_chart);
  }

  private handlePlotData(value: string, promptValue: string, displayChart = true){
    this.generatingChart[this.groupId] = true;
    if(value || !displayChart) {
      this.loadImage(value, this.groupId, promptValue);
      this.chartGenerated[this.groupId] = true;
      this.chartAPICalled[this.groupId] = true;
      this.graphLayout[this.groupId] = [];
      this.generatingResponse = false;
      this.receivedResponse[this.groupId] = true;
      this.generatingChart[this.groupId] = false;
      //scroll to chat
    } else {
      this.handleChartError(200, value || '', true, displayChart);
    }
  }

  private handleEmptyResponse() {
    this.generatingResponse = false;
    this.receivedResponse[this.groupId] = false;
    this.isLoading = false;
    this.showErrorIcon[this.groupId] = true;
    const generateErr = Messages.GENERATE_ERROR;
    const systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, new Date().toISOString(), '', '1', this.groupId);
    systemResponse.id = 'child_chat_' + this.groupId;
    systemResponse.parentId = 'chat_' + this.groupId;
    this.addMessage(systemResponse);
    this.cdRef.detectChanges();
    this.scrollToChat('SYSTEM');
  }

  private handleChatError(error: any) {
    this.generatingData[this.groupId] = false;
    if (error.error?.error?.status_code === 204) {
      this.handleEmptyResponse();
    } else {
      this.handleErrorStatus(error);
    }
    this.receivedResponse[this.groupId] = true;
    this.cdRef.detectChanges();
    this.scrollToChat('SYSTEM');
  }

  private handleErrorStatus(error: any, promptValue = '') {
    if (error.status === 503) {
      this.isDbConnectErr = true;
      this.generatingResponse = false;
      this.receivedResponse[this.groupId] = false;
      this.isLoading = false;
    } else if (error.status === 400) {
      const errMsg = error?.error_message || error.error?.error?.error_message;
      const generateErr = errMsg?.match(/^SQL injection\.*/g) ? Messages.NO_ACTION_ALLOWED : Messages.GENERATE_SQL_ERROR;
      this.showErrorIcon[this.groupId] = true;
      const systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, new Date().toISOString(), '', 'parentId', this.groupId);
      systemResponse.id = 'child_chat_' + this.groupId;
      systemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(systemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    } else if (error.status === 404 && (error?.error_message || error.error?.message_metadata?.error?.error_message)?.trim().toLowerCase() === "no dataframe found"){
      let errorMessage = '';
      if(this.groupId === 2){
        errorMessage = Messages.PREDICTION_UNAVAILABLE;
      } else {
        errorMessage = Messages.PREDICTION_NOT_GENERATED;
      }
      this.showErrorIcon[this.groupId] = true;
      const generateErr = errorMessage;
      const systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, new Date().toISOString(), '', 'parentId', this.groupId);
      systemResponse.id = 'child_chat_' + this.groupId;
      systemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(systemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    } else if(error.status === 500 && (error?.error_message || error.error?.message_metadata?.error?.error_message)?.trim().toLowerCase() === 'analytics processing failed') {
      this.showErrorIcon[this.groupId] = true;
      let formattedResponse = Messages.ANALYTICS_TIMEOUT;
      const finalSystemResponse = new ChatMessage('', formattedResponse, '', this.systemAuthor, new Date().toISOString(), promptValue, 'parentId', this.groupId);
      finalSystemResponse.id = 'child_chat_' + this.groupId;
      finalSystemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(finalSystemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    } else if(this.toolUsed[this.groupId] === 'advance_analytics' && error.status === 403 && (error?.error_message || error.error?.message_metadata?.error?.error_message)?.trim().toLowerCase() === 'advance analytics not enabled') {
      let formattedResponse = Messages.PREDICTION_DISABLED;
      const finalSystemResponse = new ChatMessage('', formattedResponse, '', this.systemAuthor, new Date().toISOString(), promptValue, 'parentId', this.groupId);
      finalSystemResponse.id = 'child_chat_' + this.groupId;
      finalSystemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(finalSystemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    } else if(error.status === 504){
      this.showErrorIcon[this.groupId] = true;
      const generateErr = Messages.GATEWAY_TIMEOUT_ERROR;
      const systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, new Date().toISOString(), '', 'parentId', this.groupId);
      systemResponse.id = 'child_chat_' + this.groupId;
      systemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(systemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    } else{
      let errorMessage = '';
      if (error.status === 500 && (error?.error_message || error.error?.message_metadata?.error?.error_message)?.trim().toLowerCase()=== "unable to complete analysis due to complexity or time constraints"){
        errorMessage = Messages.GATEWAY_TIMEOUT_ERROR;
      } else if (error.status === 500 && (error?.error_message || error.error?.message_metadata?.error?.error_message)?.trim().toLowerCase()=== "code interpreter network error"){
        errorMessage = Messages.CODE_INTERPRETER_NETWORK_ERROR;
      } else {
        errorMessage = Messages.INTERNAL_SERVER_ERROR;
      }
      this.showErrorIcon[this.groupId] = true;
      const generateErr = errorMessage;
      const systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, new Date().toISOString(), '', 'parentId', this.groupId);
      systemResponse.id = 'child_chat_' + this.groupId;
      systemResponse.parentId = 'chat_' + this.groupId;
      this.addMessage(systemResponse);
      this.generateSqlFailed = true;
      this.generatingResponse = false;
      this.isLoading = false;
    }
  }

  copyToClipboard(text:  string | undefined, groupId: number, role: string, isText: boolean = true, predictiveCopy: boolean = false) {
    if(role !== 'USER' && predictiveCopy) {
      // predictiveCopy
      this.copyPredictiveTxtResponse(groupId);

    } else {
      if(role !== 'USER' && !isText) {
        if(!this.copyCount[groupId] || this.copyCount[groupId] === 0) {
          this.copyResponse(groupId);
        }
      } else {
        if(text) {
          this.clipboard.copyFromContent(text);
          this.alertService.showSuccess(Messages.COPIED_TO_CLIPBOARD);
        }
      }
    }
  }

  addMessage(message: ChatMessage) {
    let messageIndex = this.messages.findIndex(m => m.id === message.id);
    if (messageIndex === -1) {
      this.messages.push(message);
    } else {
      this.messages[messageIndex] = message;
    }
  }

  showChartContent(role: string, groupId: number) {
    let result = this.resultObtained[groupId] || this.generatingChart[groupId] || this.chartGenerated[groupId];
    return role !== 'USER' && (result || (!this.chartGenerated[groupId] && this.chartAPICalled[groupId]));
  }

  createJsonTableData(jsonResponse: any, systemResponse: ChatMessage, promptValue: string, sql: string, isPrediction: boolean = false, sessionId: any = '') {
    return AskOurDataUtils.createJsonTableData(this.groupId, jsonResponse, systemResponse, promptValue, sql, this.dbname, this.dbId, (sessionId || this.sessionId), this.lZStringService, this.chat_id, this.oid, isPrediction);
  }

  scrollToChat(role: string) {
    let main = document.querySelector('.chat-overview-container');
    let childId = '#chat_response_' + role + '_' + this.groupId;
    let child = document.querySelector(childId);
    AskOurDataUtils.scrollToElm(main, child, 400, this.userScrolling)
  }

  viewGraph(id: number) {
    this.resultObtained[id] = true;

    this.openGraph[id] = !this.openGraph[id];
    this.cdRef.detectChanges();
    this.generatingChart[id] = true;
    if(this.openGraph[id] && (this.graphData[id] || this.graphCIData[id])) {
      let isPlotlyData = this.graphLayout[id] && Object.keys(this.graphLayout[id]).length > 0;
      if (featureFlags.askOurDataPlotlyCodeInterpreter || isPlotlyData) {
        this.plotly.plotLine("", "plot_child_chat_" + id, [...this.graphData[id]], { ...this.graphLayout[id] });
      }
      let graphDiv = document.getElementById('plot_end_'+ id);
      if (graphDiv !== null) {
        graphDiv.scrollIntoView();
      }
    } else if(!this.graphData[id] && !this.graphCIData[id]){
      this.alertService.showError('Unable to generate chart')
    }
    this.generatingChart[id] = false;
  }

  private handleChartError(status_code:any, CIPlot = '', isPredictive = false, displayChart = true): void {
    this.graphErrorMessage[this.groupId] = Messages.VISUALIZATION_NOT_GENERATED;
    if(isPredictive && CIPlot && !displayChart) {
      this.graphErrorMessage[this.groupId] = Messages.VISUALIZATION_NON_GENERATABLE;
    } else if (status_code === 400) {
      this.graphErrorMessage[this.groupId] = Messages.INSUFFICIENT_DATA_FOR_VISUALIZATION
    }
    this.chartGenerated[this.groupId] = false;
    this.chartAPICalled[this.groupId] = true;
    this.generatingChart[this.groupId] = false;
    this.graphData[this.groupId] = '';
    this.graphLayout[this.groupId] = [];
    this.cdRef.detectChanges();
  }

  regenerate() {
    // Remove entries with the current groupId from chatInteractions
    this.chatInteractions = this.chatInteractions.filter(interaction => interaction.groupId !== this.groupId);
    if (this.chatInteractions.length === 0) {
      this.chatInteractions = this.oldChatInteractions;
    }
    this.messages.pop();
    this.openGraph[this.groupId] = false;
    this.graphData[this.groupId] = '';
    this.graphCIData[this.groupId] = '';
    this.showErrorIcon[this.groupId] = false;
    this.chartGenerated[this.groupId] = false;
    this.chartAPICalled[this.groupId] = false;
    delete this.feedbackType[this.groupId];
    delete this.toolUsed[this.groupId];
    delete this.responseDataForFeedback[this.groupId];
    this.groupId--;
    this.onSubmit(this.inputPrompt, true);
  }

  toShowCopyPrompt(role: string, groupId: number): boolean {
    const isResponseReadyToCopy = !this.generatingData[groupId] && (this.receivedResponse[groupId]);
    return  role === 'USER' || (isResponseReadyToCopy && !this.showErrorIcon[groupId]);
  }

  isAfterTimestampLimit(timestamp?: string | Date): boolean {
    const limit = this.feedbackTimeStampLimit;
    const currentTime = timestamp? (new Date(timestamp)).getTime() : (new Date()).getTime();
    return currentTime > limit;
  }

  toShowFeedback(role: string, groupId: number, timestamp?: string | Date): boolean {
    const isResponseReadyToCopy = !this.generatingData[groupId] && (this.receivedResponse[groupId]);
    return  role!=='USER' && this.isAfterTimestampLimit(timestamp) && (isResponseReadyToCopy || (this.showErrorIcon[groupId]));
  }

  stopResponse() {
    this.destroy$.next(true);
    this.cdRef.detectChanges();
    this.isLoading = false;
    this.generatingResponse = false;
    this.chartAPICalled[this.groupId] = false;
    this.generatingChart[this.groupId] = false;
    this.receivedResponse[this.groupId] = true;
    this.generateSubscription?.unsubscribe();
    this.runSqlSubscription?.unsubscribe();
    this.chartSubscription?.unsubscribe();
  }

  isSubmitDisabled(): boolean {
    return (this.isLoading || this.generatingResponse || this.isDbConnectErr) || (this.generatingChart[this.groupId] && !this.chartAPICalled[this.groupId]);
  }

  back() {
     this.router.navigate(['/ask-our-data']);
  }

  startNewChat() {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
      this.router.navigate(['/ask-our-data/chat/' + this.dbId + '/' + this.dbname]));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    AskOurDataUtils.removeLocalStorage();
  }

 scrollChat(event: any) {
    this.userScrolling = !(event.target!.offsetHeight + event.target!.scrollTop >= event.target!.scrollHeight);
 }

 copyPredictiveTxtResponse = (groupId: number) : void => {

  this.copyCount[this.groupId] = 0;
  const divs = document.querySelectorAll('.copyPredictive-'+ groupId);
  if (!divs || divs.length === 0) {
    this.alertService.showError('Unable to copy');
    return;
  }

  const tempContainer = document.createElement('div');
  tempContainer.id = "tempContainer";
  tempContainer.style.position = 'absolute';
  tempContainer.style.left = '-9999px';
  tempContainer.style.whiteSpace = 'pre-wrap';
  document.body.appendChild(tempContainer);

  divs.forEach((div) => {
    const clonedDiv = div.cloneNode(true);
    tempContainer.appendChild(clonedDiv);
    tempContainer.appendChild(document.createElement('br'));
  });

  const range = document.createRange();
  range.selectNodeContents(tempContainer);
  const selection = window.getSelection();
  if (selection) {
    selection.removeAllRanges();
    selection.addRange(range);
  } else {
    this.alertService.showError('Unable to copy');
    return;
  }
  try {
    document.execCommand('copy');
    this.alertService.showSuccess('Copied to clipboard');
  } catch (err) {
    console.error('Failed to copy content:', err);
    this.alertService.showError('Unable to copy');
  }

  selection?.removeAllRanges();
  document.body.removeChild(tempContainer);
 }

 copyResponse = (groupId: number): void => {
    this.copyCount[this.groupId] = 0;
    const divs = document.querySelectorAll('.copyable-'+ groupId);
    if (!divs || divs.length === 0) {
      this.alertService.showError('Unable to copy');
      return;
    }

    const tempContainer = document.createElement('div');
    tempContainer.id = "tempContainer";
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.whiteSpace = 'pre-wrap';
    document.body.appendChild(tempContainer);

    divs.forEach((div) => {
      const clonedDiv = div.cloneNode(true);
      tempContainer.appendChild(clonedDiv);
      tempContainer.appendChild(document.createElement('br'));
    });


    let isPlotlyData = this.graphLayout[groupId] && Object.keys(this.graphLayout[groupId]).length > 0;
    if(isPlotlyData) {
      let svgContentEle = document.querySelector('.plot_' + groupId + ' .svg-container svg') as HTMLOrSVGImageElement;
      if (svgContentEle) {
        let img1 = document.createElement('img');
        let svgContentEles = document.querySelectorAll('.plot_' + groupId + ' .svg-container svg.main-svg');
        AskOurDataUtils.convertSvgToPngDataUri(svgContentEles, img1, tempContainer, this.plotly);
      } else {
        const chartContainer = document.createElement('div');
        chartContainer.style.position = 'absolute';
        chartContainer.style.left = '-9999px';
        chartContainer.style.whiteSpace = 'pre-wrap';
        chartContainer.id = "plot_temp";
        document.body.appendChild(chartContainer);

        if(this.graphData[groupId]) {
          this.plotly.plotLine("", "plot_temp", [...this.graphData[groupId]], {...this.graphLayout[groupId]});
          let img1 = document.createElement('img');
          let svgContentEles = document.querySelectorAll('#plot_temp' + ' .svg-container svg.main-svg');
          AskOurDataUtils.convertSvgToPngDataUri(svgContentEles, img1, tempContainer, this.plotly);
        }
      }
    }
    else {
      let img1 = document.createElement('img');
      img1.src = this.graphData[groupId] || this.graphCIData[groupId];
      tempContainer.appendChild(img1);
    }

    setTimeout(()=> {
      if(document.querySelectorAll('#tempContainer img').length > 0 || !this.graphData[groupId]) {
        if(this.copyInterval[this.groupId]) {
          clearInterval(this.copyInterval[this.groupId]);
          this.copyInterval[this.groupId] = null;
        }
        this.copyFromTemp(tempContainer);
      } else {
        this.copyInterval[this.groupId] = setInterval(() => {
          this.copyCount[this.groupId] = this.copyCount[this.groupId] ? this.copyCount[this.groupId] + 1 : 1;
          if(document.querySelectorAll('#tempContainer img').length > 0 || this.copyCount[this.groupId] > 10) {
            this.copyFromTemp(tempContainer);
            clearInterval(this.copyInterval[this.groupId]);
            this.copyInterval[this.groupId] = null;
          }
        }, 300);
      }
    }, 500);

  }

  copyFromTemp = (tempContainer: any): void => {
    this.copyCount[this.groupId] = 0;
    const range = document.createRange();
    range.selectNodeContents(tempContainer);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    } else {
      this.alertService.showError('Unable to copy');
      return;
    }
    try {
      document.execCommand('copy');
      this.alertService.showSuccess('Copied to clipboard');
    } catch (err) {
      console.error('Failed to copy content:', err);
      this.alertService.showError('Unable to copy');
    }

    selection?.removeAllRanges();
    document.body.removeChild(tempContainer);

  }

  convertSvgToPngDataUri(svgDataEles: any, image: any, tempContainer: any): any {
       this.plotly.convertSVGsToSingleImage(svgDataEles).then(source => {
        image.addEventListener('load', () => {
          const canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(image, 0, 0);
            const pngDataUri = canvas.toDataURL('image/png');
            image.src = pngDataUri;
            tempContainer.appendChild(image);
          } else {
            console.error('Failed to convert SVG to PNG');
          }
        })
        image.src = source;
      });
  }

  continue() {
    this.askOurDataService.saveConsent({
      "user_id": this.oid,
      "database_id": this.dbId
    }).subscribe({
      next: () => {
        this.kmdModalService.close('consentModal');
      },
      error: () => {
        this.kmdModalService.close('consentModal');
        this.back();
      }
    });
  }

  isChecked(value: any){
    this.consent = value?.checked;
  }

  onChipClick($prompt: SamplePrompt) {
    this.promptInputComponent.setPromptAndFocus($prompt.question);
  }

  onSamplePromptsReceived(prompts: SamplePrompt[]) {
    this.samplePrompts = prompts;
  }

  isInputPromptSameAsSamplePrompt(inputPrompt: string, samplePrompts: SamplePrompt[]): number {
    const normalizedInput = inputPrompt.trim().toLowerCase().replace(/\s+/g, ' ');
    return samplePrompts.findIndex((samplePrompt) =>
      samplePrompt.question?.trim().toLowerCase().replace(/\s+/g, ' ') === normalizedInput
    );
  }

  handlePrompt(inputPrompt: string) {
    this.onSubmit(inputPrompt);
  }

  displayLoader(status: any) {
    this.showLoader = status;
  }

  getData(id: any) {
    return this.predictiveText[id];
  }

  toggleDatabaseDropdown() {
    this.showModelDropdown = !this.showModelDropdown;
    this.modelDropdown.toggleMenu();
  }

  isContextMenuOpen(isOpen: any) {
    this.showModelDropdown = isOpen;
  }

  closeDropdownMenu() {
    if (this.showModelDropdown) {
      this.showModelDropdown = !this.showModelDropdown;
      this.modelDropdown.toggleMenu();
    }
  }

  menuItemSelected(menuItem: ContextMenuItem) {
    switch (menuItem.label) {
      case "History":
            this.chatHistoryComponent.openChatHistory();
            break;
      default:
    }
  }

  onFeedbackFormClosed(groupId: number): void {
    delete this.feedbackType[groupId];
  }

  openFeedbackFormEvent(event: {groupId: number, feedbackType: string | null}): void {
    this.feedbackFormOpened[event.groupId] = event.feedbackType || '';
  };

  clearChat() {
    this.ischatEmpty = true;
    this.messages = [];
    this.showErrorIcon = [];
    this.stopResponse();
    this.groupId = 1;
    this.chatInteractions = [];
    this.receivedResponse[this.groupId] = false;
    this.graphData = [];
    this.graphCIData= [];
    this.graphLayout = {};
    this.openGraph = [];
    this.resultObtained = [];
    this.sqlResultObtained = [];
    this.isConversationResponse = [];
    this.graphErrorMessage = [];
    this.feedbackType = {};
    this.toolUsed = {};
    this.chatIdMap = {};
    this.userInputPrompt = {};
    this.responseDataForFeedback = {};
  }

  // Display chat history
  displayChat(chatData: any) {
    let session_id = chatData.session_id;
    let chatDetails = chatData.details;
    if(session_id === this.sessionId || chatDetails.length > 0) {
      this.clearChat();
      const userAuthor = this.userAuthor;
      const systemAuthor = this.systemAuthor;
      let chatIdList: number[] = [];

      chatDetails.forEach((chatDetail: any) => {
          if(chatDetail.chat_history_summary) {
            chatIdList.push(chatDetail.chat_id);
          }
      });

      let latestChatSummaryId = chatIdList.length > 0 ? chatIdList[chatIdList.length - 1] : chatDetails[0].chat_id;

      chatDetails.forEach((chatDetail: any, i: number) => {
        this.groupId++;
        this.chat_id = chatDetail.chat_id;
        this.chatIdMap[this.groupId] = chatDetail.chat_id;
        this.userInputPrompt[this.groupId] = chatDetail.user_query;

        if (chatDetail.is_useful !== null && chatDetail.is_useful !== undefined) {
          this.feedbackType[this.groupId] = chatDetail.is_useful === true ? 'thumbsUp' : 'thumbsDown';
        }
        if (chatDetail.tool_used) {
          this.toolUsed[this.groupId] = chatDetail.tool_used;
        }

        const userMessage = new ChatMessage('', chatDetail.user_query, '', userAuthor, chatDetail.timestamp, chatDetail.user_query, '', this.groupId);
        userMessage.id = 'chat_' + this.groupId;
        this.addMessage(userMessage);

        this.chartGenerated[this.groupId] = false;

        const metadata = isObject(chatDetail.message_metadata) ? chatDetail.message_metadata : JSON.parse(chatDetail.message_metadata || '{}');
        let statusCode = metadata?.error?.status_code || metadata?.status_code
        if (statusCode) {
          if(metadata.error?.type) {
            switch(metadata.error?.type) {
              case "plot":
                this.handleNonSqlResponseForHistory(chatDetail, userMessage, systemAuthor, latestChatSummaryId);
                this.handleChartError(metadata.error?.status_code);
                break;
              case "sql":
              case "run":
                this.handleErrorFromChatDetail(chatDetail, latestChatSummaryId, metadata, userMessage);
                break;
              case "analytics":
              case "chat":
                this.handleGenerateSqlErr(metadata.error || metadata, this.groupId, chatDetail.sql_generated, chatDetail.timestamp);
                break;
            }
          } else {
            this.handleErrorFromChatDetail(chatDetail, latestChatSummaryId, metadata, userMessage);
          }
        } else {
          this.handleNonSqlResponseForHistory(chatDetail, userMessage, systemAuthor, latestChatSummaryId);
        }

        if (i === chatDetails.length - 1) {
          this.ischatEmpty = false;
          this.sessionId = chatDetail.session_id;
          for(let j = 1; j<= chatDetails.length + 1; j++) {
            this.receivedResponse[j] = true;
          }
          this.inputPrompt = chatDetail.user_query;
        }
      });
    }
  }

  private handleErrorFromChatDetail(chatDetail: any, latestChatSummaryId: any, metadata: any, userMessage: any){

    if (chatDetail.sql_generated) {
      // this.groupId++;
      this.addChatInteraction(chatDetail, latestChatSummaryId);
      const systemResponse = this.createSystemMessage(chatDetail.sql_generated, userMessage.id, chatDetail.timestamp);
      this.addMessage(systemResponse);
    }
    this.handleGenerateSqlErr(metadata.error || metadata, this.groupId, chatDetail.sql_generated, chatDetail.timestamp);
  }

  private addChatInteraction(chatDetail: any, latestChatSummaryId: number) {
    let chat_id = chatDetail?.chat_id;
    let userQuery = chatDetail?.user_query;
    let sqlGenerated = chatDetail?.sql_generated;
    let chat_history = chatDetail?.chat_history_summary;
    if (chat_id > latestChatSummaryId || (chat_id === latestChatSummaryId && !chatDetail.chat_history_summary)) {
      this.chatInteractions.push(
        {groupId: this.groupId, role: "user", content: userQuery, content_type: "Question" },
        {groupId: this.groupId, role: "assistant", content: sqlGenerated, content_type: "sql" }
      );
    } else if (chat_id === latestChatSummaryId && chatDetail.chat_history_summary) {
      this.chatInteractions.push({
        "groupId": this.groupId,
        "role": "assistant",
        "content": chat_history,
        "content_type": "chat_history_summary"
      });
    }
  }

  private createSystemMessage(content: string, parentId: string | undefined, timestamp?: string) {
    const systemResponse = new ChatMessage('', content, '', this.systemAuthor, timestamp || new Date().toISOString(), content, parentId, this.groupId);
    systemResponse.id = 'child_chat_' + this.groupId;
    systemResponse.parentId = 'chat_' + this.groupId;
    return systemResponse;
  }

  private handleNonSqlResponseForHistory(chatDetail: any, userMessage: ChatMessage, systemAuthor: ChatAuthor, latestChatSummaryId: number) {
    if (chatDetail.message_type === 'Non-SQL' ) {
      if(chatDetail.data_summary) {
        let chatInteractionDataForAssistant = '';
        this.isConversationResponse[this.groupId] = true;
        let predictiveText = chatDetail.data_summary;
        try {
          let updatedPredictiveText = { ...predictiveText };
          delete updatedPredictiveText.original_dataframe;
          delete updatedPredictiveText.s3_link;
          delete updatedPredictiveText.base64_string;
          delete updatedPredictiveText.display_chart;
          delete updatedPredictiveText.sql_query;
          this.responseDataForFeedback[this.groupId] = JSON.stringify(updatedPredictiveText) || null;

          predictiveText = JSON.parse(chatDetail.data_summary || "{}")?.result;
          chatInteractionDataForAssistant = predictiveText?.analysis_output || '';
          let predictiveContent = '';
          if(predictiveText.key_takeaways) {
            predictiveContent += '## Key Takeaways: \n' + predictiveText.key_takeaways.join(' \n');
          }
          if(predictiveText.recommendations) {
            predictiveContent += '\n ## Recommendations: \n' + predictiveText.recommendations.join(' \n');
          }
         // const formattedResponse = `<div class="copyable-${this.groupId}">${predictiveText?.analysis_output || ''}</div>`;
          const finalSystemResponse = new ChatMessage((predictiveText?.analysis_output || ''), '', predictiveContent, systemAuthor, chatDetail.timestamp, chatDetail.user_query , '1', this.groupId);
          finalSystemResponse.id = 'child_chat_' + this.groupId;
          finalSystemResponse.parentId = 'chat_' + this.groupId;
          this.addMessage(finalSystemResponse);
          this.handlePlotlyGraph(chatDetail, true, predictiveText.display_chart);

          let updatedDataframe = JSON.parse(chatDetail?.data_frame || "[]");
          if(updatedDataframe && updatedDataframe.length > 0) {
            const tableResponse = this.createJsonTableData(updatedDataframe, finalSystemResponse, chatDetail.user_query, chatDetail.sql_generated, true, chatDetail.session_id);
            const finalPredictiveSystemResponse = new ChatMessage(finalSystemResponse.mainContent, tableResponse, predictiveContent, this.systemAuthor, chatDetail.timestamp, chatDetail.user_query, userMessage.id, this.groupId);
            finalPredictiveSystemResponse.id = 'child_chat_' + this.groupId;
            finalPredictiveSystemResponse.parentId = 'chat_' + this.groupId;
            this.addMessage(finalPredictiveSystemResponse);
          }
        } catch (e) {
          chatInteractionDataForAssistant = chatDetail.data_summary;
          this.responseDataForFeedback[this.groupId] = chatDetail.data_summary;
          console.log("Error parsing JSON:", e);
          if (chatDetail.data_summary.trim().toLowerCase() === Messages.GENERATE_ERROR.trim().toLowerCase()) {
            this.showErrorIcon[this.groupId] = true;
          }
          const systemResponse = new ChatMessage(chatDetail.data_summary, '', '', systemAuthor, chatDetail.timestamp, chatDetail.user_query, userMessage.id, this.groupId);
          systemResponse.id = 'child_chat_' + this.groupId;
          systemResponse.parentId = 'chat_' + this.groupId;
          this.addMessage(systemResponse);
       }
        let chat_id = chatDetail?.chat_id;
        if (chat_id > latestChatSummaryId || (chat_id === latestChatSummaryId && !chatDetail.chat_history_summary)) {
          this.chatInteractions.push(
            { groupId: this.groupId, role: "user", content: chatDetail.user_query, content_type: "Question" },
            { groupId: this.groupId, role: "assistant", content: chatInteractionDataForAssistant, content_type: "chat_response" }
          );
        } else if (chat_id === latestChatSummaryId && chatDetail.chat_history_summary) {
          this.chatInteractions.push({
            "groupId": this.groupId,
            "role": "assistant",
            "content": chatDetail.chat_history_summary,
            "content_type": "chat_history_summary"
          });
        }
      } else {
        let chat_id = chatDetail?.chat_id;
        if (chat_id > latestChatSummaryId || (chat_id === latestChatSummaryId && !chatDetail.chat_history_summary)) {
          this.chatInteractions.push(
            { groupId: this.groupId, role: "user", content: chatDetail.user_query, content_type: "Question" }
          );
        } else if (chat_id === latestChatSummaryId && chatDetail.chat_history_summary) {
          this.chatInteractions.push({
            "groupId": this.groupId,
            "role": "assistant",
            "content": chatDetail.chat_history_summary,
            "content_type": "chat_history_summary"
          });
        }
      }
    } else if (chatDetail.sql_generated) {
      this.handleSqlResponse(chatDetail, userMessage, latestChatSummaryId);
    }
  }

  private handleSqlResponse(chatDetail: any, userMessage: ChatMessage, latestChatSummaryId: number) {
    let isChatResponse = false;
    this.responseDataForFeedback[this.groupId] = chatDetail.sql_generated;
    let systemResponse = this.createSystemMessage(chatDetail.sql_generated, userMessage.id, chatDetail.timestamp);
    this.addChatInteraction(chatDetail, latestChatSummaryId);
    let chat_id = chatDetail?.chat_id;

    let systemRunSqlResponse: ChatMessage = new ChatMessage('', '', '', this.systemAuthor, chatDetail.timestamp, '', '', this.groupId);
    if (chatDetail?.data_frame) {
      const jsonResponse = JSON.parse(chatDetail?.data_frame || "[]");
      const responseMessage = this.createJsonTableData(jsonResponse, systemResponse, chatDetail.user_query, chatDetail.sql_generated, false, chatDetail.session_id);
      systemRunSqlResponse = new ChatMessage(systemResponse.text , responseMessage, '', this.systemAuthor, chatDetail.timestamp, chatDetail.user_query, userMessage.id, this.groupId, chatDetail.data_summary, chatDetail.sql_generated);

      if (chat_id > latestChatSummaryId || chat_id === latestChatSummaryId) {
        this.chatInteractions.push({
          groupId: this.groupId,
          role: "assistant",
          content: JSON.stringify(jsonResponse.slice(0, this.chatHistoryDataLimit)),
          content_type: "sql_result"
        });
        this.chatInteractions.push({
          groupId: this.groupId,
          role: "assistant",
          content: chatDetail.data_summary || 'No results or match was found for the query',
          content_type: "sql_result_summary"
        });
      }

    } else if(chatDetail.data_summary){
      isChatResponse = true;
      if (chat_id > latestChatSummaryId || chat_id === latestChatSummaryId) {
        this.chatInteractions.push(
          { groupId: this.groupId, role: "user", content: chatDetail.user_query, content_type: "Question" },
          { groupId: this.groupId, role: "assistant", content: chatDetail.data_summary, content_type: "chat_response" }
        );
      }

    } else {
      systemResponse = this.handleEmptySqlResponse(chatDetail, systemResponse, latestChatSummaryId);
    }

    systemRunSqlResponse.id = 'child_chat_' + this.groupId;
    systemRunSqlResponse.parentId = 'chat_' + this.groupId;

    if(isChatResponse) {

      try {
        let predictiveText = JSON.parse(chatDetail.data_summary || "{}")?.result;
        const finalSystemResponse = new ChatMessage((predictiveText?.analysis_output || ''), '', '', this.systemAuthor, chatDetail.timestamp, chatDetail.user_query , '1', this.groupId);
        finalSystemResponse.id = 'child_chat_' + this.groupId;
        finalSystemResponse.parentId = 'chat_' + this.groupId;
        this.addMessage(finalSystemResponse);
        this.handlePlotlyGraph(chatDetail, true, predictiveText.display_chart);

        let updatedDataframe = JSON.parse(chatDetail?.data_frame || "[]");
        if(updatedDataframe && updatedDataframe.length > 0) {
          const tableResponse = this.createJsonTableData(updatedDataframe, finalSystemResponse, chatDetail.user_query, chatDetail.sql_generated, true, chatDetail.session_id);
          const finalPredictiveSystemResponse = new ChatMessage(finalSystemResponse.mainContent, tableResponse, '', this.systemAuthor, chatDetail.timestamp, chatDetail.user_query, userMessage.id, this.groupId);
          finalPredictiveSystemResponse.id = 'child_chat_' + this.groupId;
          finalPredictiveSystemResponse.parentId = 'chat_' + this.groupId;
          this.addMessage(finalPredictiveSystemResponse);
        }
      } catch (e) {
        console.log("Error parsing JSON:", e);
        const formattedResponse = chatDetail.data_summary;
        const finalSystemResponse = new ChatMessage(formattedResponse, '', '', this.systemAuthor, chatDetail.timestamp, chatDetail.user_query, userMessage.id, this.groupId);
        finalSystemResponse.id = 'child_chat_' + this.groupId;
        finalSystemResponse.parentId = 'chat_' + this.groupId;
        this.isConversationResponse[this.groupId] = true;
        this.addMessage(finalSystemResponse);
     }
    } else {
      this.addMessage(systemResponse);
      if(systemRunSqlResponse.text) {
        this.addMessage(systemRunSqlResponse);
      }
    }

    if (chatDetail.plotly_graph) {
      this.handlePlotlyGraph(chatDetail);
    } else if (chatDetail?.data_frame ) {
      this.handleChartError(chatDetail?.message_metadata?.chartAPIError?.status_code);
      this.resultObtained[this.groupId] = true;
      this.sqlResultObtained[this.groupId] = true;
    }
  }

  private handleEmptySqlResponse(chatDetail: any, systemResponse: ChatMessage, latestChatSummaryId: number) {

    let chat_id = chatDetail?.chat_id;
    if (chat_id > latestChatSummaryId || chat_id === latestChatSummaryId) {
      this.chatInteractions.push({
        groupId: this.groupId,
        role: "assistant",
        content: JSON.stringify([]),
        content_type: "sql_result"
      });
      this.chatInteractions.push({
        groupId: this.groupId,
        role: "assistant",
        content: 'No results or match was found for the query',
        content_type: "sql_result_summary"
      });
    }

    if (chatDetail.sql_generated) {
      this.showErrorIcon[this.groupId] = true;
      const sqlErr = `<p>${chatDetail.sql_generated}</p><p>${Messages.NO_RESPONSE}</p>`;
      systemResponse = new ChatMessage('', sqlErr, '', this.systemAuthor, chatDetail.timestamp, systemResponse.prompt, 'childId_' + this.groupId, this.groupId);
    } else {
      systemResponse = new ChatMessage('', Messages.NO_RESPONSE, '', this.systemAuthor, chatDetail.timestamp, chatDetail.user_query, systemResponse.id, this.groupId);
    }
    return systemResponse;
  }

  nonPlotly(groupId: number) {
    return this.graphLayout[groupId] && Object.keys(this.graphLayout[groupId]).length === 0;
  }

  private handlePlotlyGraph(chatDetail: any, isPredictive = false, displayChart = true) {
    if((!isPredictive && chatDetail.plotly_graph) || (displayChart && chatDetail.plotly_graph)) {
      let graph;
      try{
        graph = JSON.parse(chatDetail.plotly_graph);
      } catch(e) {
        console.log("Error parsing JSON:", e);
        graph = chatDetail.plotly_graph;
      }
      if(graph && !graph.data) {
        this.graphData[this.groupId] = `data:image/png;base64,${graph}`;
        this.graphLayout[this.groupId] = {};
        // this.viewGraph(this.groupId, '', '');
        // this.openGraph[this.groupId] = true;
      } else {
        this.graphData[this.groupId] = graph.data;
        this.graphLayout[this.groupId] = graph.layout || {};
      }
      this.chartGenerated[this.groupId] = true;
      this.chartAPICalled[this.groupId] = true;
      this.sqlResultObtained[this.groupId] = true;
    }
    else {
      this.handleChartError(chatDetail?.message_metadata?.chartAPIError?.status_code, (isPredictive && chatDetail.plotly_graph) ? chatDetail.plotly_graph : '', isPredictive, displayChart);
    }
  }

  handleGenerateSqlErr(error: any, groupId: any, sql: string | null, timestamp: string) {
    this.showErrorIcon[groupId] = true;
    let errMsg = (error.value || error.error_message) || '';
    let injectionErrCheck = errMsg?.match(/^SQL injection\.*/g);
    let injectionErr = injectionErrCheck ? Messages.NO_ACTION_ALLOWED :  (!sql ? Messages.GENERATE_SQL_ERROR : Messages.NO_RESPONSE);
    let generateErr =  (errMsg.match(/^Syntax error\.*/g)) ? Messages.GENERATE_SQL_ERROR : injectionErr;

    if (error.status_code === 504) {
      generateErr = '<p>' + Messages.GATEWAY_TIMEOUT_ERROR + '</p>';
    } else  if(error.status_code === 204) {
      generateErr = '<p>' + sql + '</p>' + generateErr;
    }
    else if(error.status_code === 500) {
      if (errMsg.trim().toLowerCase()=== "unable to complete analysis due to complexity or time constraints") {
        generateErr = '<p>' + Messages.GATEWAY_TIMEOUT_ERROR + '</p>';
      } else if (errMsg.trim().toLowerCase()=== "code interpreter network error") {
        generateErr = '<p>' + Messages.CODE_INTERPRETER_NETWORK_ERROR + '</p>';
      } else if (errMsg.trim().toLowerCase()=== "analytics processing failed") {
        generateErr = '<p>' + Messages.ANALYTICS_TIMEOUT + '</p>';
      } else {
        generateErr = '<p>' + Messages.INTERNAL_SERVER_ERROR + '</p>';
      }
    } else if(error.status_code === 403 && errMsg.trim().toLowerCase() === 'advance analytics not enabled') {
      generateErr = '<p>' + Messages.PREDICTION_DISABLED + '</p>';
      this.showErrorIcon[groupId] = false;
    } else if(error.status_code === 404 && errMsg.trim().toLowerCase() === 'no dataframe found') {
      if (groupId ===2) {
        generateErr = '<p>' + Messages.PREDICTION_UNAVAILABLE + '</p>';
      } else {
        generateErr = '<p>' + Messages.PREDICTION_NOT_GENERATED + '</p>';
      }
    }
    let systemResponse = new ChatMessage('', generateErr, '', this.systemAuthor, timestamp || new Date().toISOString(), '', 'parentId', groupId);
    systemResponse.id = 'child_chat_' + groupId;
    systemResponse.parentId = 'chat_' + groupId;
    this.addMessage(systemResponse);
    this.generatingResponse = false;
    this.receivedResponse[this.groupId] = true;
  }

  //display chat history end

  copyCodeInterpreterChart(groupId: number) {

    const tempContainer = document.createElement('div');
    tempContainer.id = "tempContainer";
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.whiteSpace = 'pre-wrap';
    document.body.appendChild(tempContainer);

    let img1 = document.createElement('img');
    img1.src = this.graphData[groupId] || this.graphCIData[groupId];
    tempContainer.appendChild(img1);

    setTimeout(()=> {
      if(document.querySelectorAll('#tempContainer img').length > 0 || !this.graphData[groupId]) {
        if(this.copyInterval[this.groupId]) {
          clearInterval(this.copyInterval[this.groupId]);
          this.copyInterval[this.groupId] = null;
        }
        this.copyFromTemp(tempContainer);
      } else {
        this.copyInterval[this.groupId] = setInterval(() => {
          this.copyCount[this.groupId] = this.copyCount[this.groupId] ? this.copyCount[this.groupId] + 1 : 1;
          if(document.querySelectorAll('#tempContainer img').length > 0 || this.copyCount[this.groupId] > 10) {
            this.copyFromTemp(tempContainer);
            clearInterval(this.copyInterval[this.groupId]);
            this.copyInterval[this.groupId] = null;
          }
        }, 300);
      }
    }, 500);
  }

  downloadCodeInterpreterChart(groupId: number) {
    try {
      let date = new Date();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = this.graphData[groupId] || this.graphCIData[groupId];
      downloadLink.download = 'chart_' + date.getTime() + '.png';
      downloadLink.style.display = 'none';

      // Append, trigger download, and remove link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      this.alertService.showSuccess('Chart downloaded successfully!');
    } catch (error) {
      console.error('Failed to download chart:', error);
      this.alertService.showError('Unable to download chart');
    }
  }

  onTabOpen() {
    this.isExpanded = true;
  }

  onTabClose() {
    this.isExpanded = false;
  }

  private loadImage(s3URL: string, groupId: any, promptValue: string = ''): void {

      const imageLoader$ = this.http.get(s3URL, {
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        tap((response: any) => {
          if (response?.status !== 200) {
            throw new Error(`HTTP status ${response?.status}`);
          }
        }),
        switchMap((response: any) => from(this.blobToDataUrl(response?.body!, groupId, promptValue))),
        catchError(() => {
          this.graphLayout = {};
          this.chartAPICalled[groupId] = true;
          this.chartGenerated[groupId] = false;
          return of(null);
        }),
        shareReplay(1),
        takeUntil(this.destroy$)
      );

      imageLoader$.subscribe({
        next: (dataUrl) => {
          if (dataUrl) {
              const keywordList = ['plot', 'graph', 'display', 'chart', 'visualize', 'draw', 'histogram', 'heatmap'];
              const promptValueLowerCase = promptValue.toLowerCase();

              if (
                promptValueLowerCase.split(' ').some((word) => keywordList.includes(word)) ||
                ['bar chart', 'line chart', 'pie chart'].some((chartType) => promptValueLowerCase.includes(chartType))
              ) {
                this.viewGraph(groupId);
              }
              this.cdRef.detectChanges();
          }
        },
        error: () => {
          this.graphLayout = {};
          this.chartAPICalled[groupId] = true;
          this.chartGenerated[groupId] = false;
          return of(null);
        }
      });

  }

  private blobToDataUrl(blob: Blob, groupId: any, promptValue: string = ''): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        if (result) {
          this.graphData[groupId] = result;
          this.graphLayout[groupId] = {};
          const keywordList = ['plot', 'graph', 'display', 'chart', 'visualize', 'draw', 'histogram', 'heatmap'];
          const promptValueLowerCase = promptValue.toLowerCase();

          if (
            promptValueLowerCase.split(' ').some((word) => keywordList.includes(word)) ||
            ['bar chart', 'line chart', 'pie chart'].some((chartType) => promptValueLowerCase.includes(chartType))
          ) {
            this.viewGraph(groupId);
          }
          this.cdRef.detectChanges();
          resolve(result);
        } else {
          this.graphLayout = {};
          this.chartAPICalled[groupId] = true;
          this.chartGenerated[groupId] = false;
          reject(new Error('FileReader returned null result'));
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  }

}

function capitalizeFirstLetter(key: string): string {
  if (!key || typeof key !== 'string') {
    return key;
  }
  key = key.replace(/_/g, ' ');
  return key.charAt(0).toUpperCase() + key.slice(1);
}
